import { render, staticRenderFns } from "./KitHeader.vue?vue&type=template&id=2454b34a&scoped=true&"
import script from "./KitHeader.vue?vue&type=script&lang=js&"
export * from "./KitHeader.vue?vue&type=script&lang=js&"
import style0 from "./KitHeader.vue?vue&type=style&index=0&id=2454b34a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2454b34a",
  null
  
)

export default component.exports